import type { Metadata } from "next";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";

export const metadata: Metadata = {
  title: "v0 App",
  description: "Created with v0",
  generator: "v0.dev",
};

const ThoughtCoCreateLayout = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      console.log(123, location.hash)
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location]);
  return (
    <>
      <Outlet />
    </>
  );
};

export default ThoughtCoCreateLayout;
